import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import esLocale from '@fullcalendar/core/locales/es'
import './Calendar.css'

const Calendar = ({useFetchInit}) => {

    const {
        globalStates,
        FetchData,
        Actions
    } = useFetchInit

    const { fetchAllEvents } = FetchData
    const { dataEvents } = fetchAllEvents

    const { calendarRef } = globalStates

    const { handleCustomButtonClick, handleClickShowModal, openModal } =  Actions

    return (
        <div className="content">
            <FullCalendar
                plugins={[ dayGridPlugin, timeGridPlugin]} //Extraer las vistas de mes, semana, día y lista
                selectable={true} //Permite seleccionar un evento
                displayEventTime={false} //Se muestra el tiempo del evento
                initialView="dayGridMonth" //Vista de mes predeterminada al entrar al calendiario
                timeZone="GTM-6" //Zona horaria
                locale={esLocale} //Es una función descargada de fullcalendar para mostrar información en español
                //Se muestran los eventos extraídos de la bd
                events={dataEvents}
                //Personalización del tamaño del texto
                eventContent={(arg) => {
                    return <span style={{fontSize: '0.6vw'}}>{arg.event.title}</span> 
                }}
                //Personalización de botones
                customButtons={
                    {
                        customButtonPrev: {
                            icon: "chevron-left",
                            click: function() {
                                // Movilización previa de fecha
                                calendarRef.current.getApi().prev()

                                //FUNCIÓN PARA EXTRAER MES Y ASÍ EXTRAER LA DATA PARA RESPECTIVO MES
                                handleCustomButtonClick()
                            }
                        },
                        customButtonNext: {
                            icon: "chevron-right",
                            click: function() {
                                // Movilización posterior de fecha
                                calendarRef.current.getApi().next();

                                //FUNCIÓN PARA EXTRAER MES Y ASÍ EXTRAER LA DATA PARA RESPECTIVO MES
                                handleCustomButtonClick()
                            }
                        },
                        customButtonAddEvent: {
                            text: 'Agregar evento',
                            click: () => openModal("", "", "event-form", {})
                        },
                        customButtonToday: {
                            text: "Hoy",
                            click: function() {
                                // Movilización de fecha a Hoy
                                calendarRef.current.getApi().today();

                                //FUNCIÓN PARA EXTRAER MES Y ASÍ EXTRAER LA DATA PARA RESPECTIVO MES
                                handleCustomButtonClick()
                            }
                        }
                    }
                }
                //Header  del calendario, se agregan los botones personalizados y las vistas disponibles
                headerToolbar={{
                    left: "customButtonPrev,customButtonNext customButtonToday customButtonAddEvent",
                    center: "title",
                    right: "dayGridMonth,timeGridDay"
                }}
                height={730} //Tamaño específico del calendario a lo largo
                aspectRatio={2.5} //Función para ajustar el calendario en las pantallas
                eventClick={(info) => handleClickShowModal( info.event )} // Evento Clic para mostar modal
                ref={calendarRef} //Variable para referencia a este mismo calendario
                //Ajustes dependiendo de la vista
                views={{
                    timeGridDay: {
                        type: 'timeGridDay',
                        slotLabelFormat: () => '',
                        allDaySlot:true,
                        slotDuration: '24:00',
                        dayMaxEventRows: 20, //Limita eventos visibles en la franja "Todo" y agrega el enlace "+X más" (con scroll) para el resto
                    },
                    dayGridMonth: {
                        dayMaxEventRows: 15
                    }
                }}
            />
        </div>
    )
}

export {
    Calendar
}
